import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fetchPublicServices } from "../lib/servicesApi";

export default function Services() {
  const [services, setServices] = useState(null);

  useEffect(() => {
    fetchPublicServices()
      .then(setServices)
      .catch(() => setServices([]));
  }, []);

  return (
    <section id="services" className="relative py-24 md:py-36 px-6 md:px-12" data-testid="services-section">
      <div className="max-w-[1600px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="flex items-end justify-between mb-12 md:mb-16 gap-6 flex-wrap"
        >
          <div>
            <div className="text-[11px] tracking-[0.32em] uppercase text-white/50 mb-4">02 — Services</div>
            <h2 className="font-anton uppercase text-5xl md:text-7xl leading-[0.9] tracking-tight max-w-3xl">
              Buy only the help <span className="text-[#2A5BFF]">you need.</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-sm font-light leading-relaxed">
            Pay per service, get expert eyes on it, move on stronger.
          </p>
        </motion.div>

        {services === null && (
          <div className="text-white/40 text-sm py-8" data-testid="home-services-loading">Loading…</div>
        )}

        {services && services.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
            {services.map((s, i) => (
              <motion.div
                key={s.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
                className="-ml-px -mt-px"
              >
                <Link
                  to="/services"
                  className="service-card group relative p-6 md:p-8 min-h-[220px] flex flex-col justify-between h-full"
                  data-testid={`service-card-${s.slug}`}
                >
                  <div className="flex items-start justify-between">
                    <span className="text-[10px] tracking-[0.28em] uppercase text-white/40">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <ArrowUpRight
                      size={20}
                      className="text-white/40 transition-all duration-300 group-hover:text-[#2A5BFF] group-hover:translate-x-1 group-hover:-translate-y-1"
                    />
                  </div>
                  <div>
                    <h3 className="font-anton uppercase text-2xl md:text-3xl leading-tight tracking-wide">
                      {s.title}
                    </h3>
                    <div className="mt-3 text-[11px] tracking-[0.28em] uppercase text-white/40 group-hover:text-[#2A5BFF] transition-colors">
                      {s.tag}
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
